import classes from './SelectableCardHeader.module.scss'

interface Props {
  children: React.ReactNode
}

export function SelectableCardHeader({ children }: Props) {
  return <div className={classes.SelectableCardHeader}>{children}</div>
}
